import { CustomerChangePasswordPage } from '@/pages/customer-portal/profile/CustomerChangePasswordPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer/_customer-authenticated/change-password')({
	component: CustomerChangePasswordRoute,
});

function CustomerChangePasswordRoute() {
	return <CustomerChangePasswordPage />;
}
